module.exports = __webpack_public_path__ + "img/tea.19d220ac.svg";